import { render } from "./CuentaPresupuestosSoloLectura.vue?vue&type=template&id=4abdd7a7"
import script from "./CuentaPresupuestosSoloLectura.vue?vue&type=script&lang=js"
export * from "./CuentaPresupuestosSoloLectura.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__